import { render } from "./tw-ws-histogram.vue?vue&type=template&id=268ea4db"
import script from "./tw-ws-histogram.vue?vue&type=script&lang=js"
export * from "./tw-ws-histogram.vue?vue&type=script&lang=js"
script.render = render

export default script